import { Button, Card, Col, DatePicker, Form, message, Row, Space, Spin, Tag } from "antd";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { calCulateVatInPercent } from "../../../../../utils/helper";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms//FormElement/InputNumberField";
import { InputSwitch, ReactSelectField, TextAreaField } from "../../../../atoms/FormElement";
import { ApprovalHeader } from "../../../BookingForm/components/utils";
import { apiDateFormat } from "../../../Maintenance/Roster/components/utils";
import { usePendingRequestsActions } from "../../../PendingApprovalRequets/api/useRefreshPendingRequests";
import { type ReceiptDeferPayload, postReceiptDefer } from "../../Receipts/api/receiptActions";
import { updatePdcDefer } from "../../ducks/actions";
import { useInvoiceActionNavigation } from "../../hooks/useInvoiceActionNavigation";
import { deferDefaultFormVal, paymentModeRendering, removeEmptyValues } from "../../utili";

var _ = require("lodash");

const defaultVal = deferDefaultFormVal;

const DeferChequeDeposit = (props) => {
  const { data } = props;
  const dateFormat = "YYYY-MM-DD";
  let chequeDate = data?.params?.data?.chequeDate
    ? dayjs(data?.params?.data?.chequeDate, dateFormat)
    : dayjs(new Date(Date.now()));
  let deferredDate =
    (data?.params?.data?.deferredDate && dayjs(data?.params?.data?.deferredDate, dateFormat)) || chequeDate;
  const [datePicker, setdatePicker] = useState(chequeDate);
  const [newDepositDate, setNewDepositDate] = useState(deferredDate);
  let isRejection = data?.selectedOption === "reject_pending_request";
  let isApproved = data?.selectedOption === "approve_pending_request";
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [onApprovalConfirmation, setOnApprovalConfirmation] = useState(false);
  const isDeferralApproval = data?.params?.data?.chequeDeferral?.approval?.toLowerCase() === "enable" || false;
  const deferredRequest = data?.params?.data?.deferredRequest === "pending";
  const maxDeferralDays = data?.params?.data?.chequeDeferral?.maxdeferraldays; // example value
  const deferralFee = deferredRequest
    ? data?.params?.data?.deferred?.amount
    : (data?.params?.data?.chequeDeferral?.amount ?? 0);
  const vatPercent = deferredRequest
    ? data?.params?.data?.deferred?.vat
    : (data?.params?.data?.chequeDeferral?.vat ?? 0);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      ...defaultVal,
      paymentRef: data?.params?.data?.documentNo,
      deferralFee: deferralFee || 0,
      vat: vatPercent || 0,
    },
  });
  const switcherValue = useWatch({
    control,
    name: ["isApplyDefferalFee", "deferralFee", "vat"],
  });
  const onBack = () => {
    reset();
    props.onCancel();
  };

  const { refreshPendingRequests } = usePendingRequestsActions();
  const { goTo, pdcId: serachParampdcId } = useInvoiceActionNavigation();
  const isReceiptContext = Boolean(data?.params?.data?.paymentReceiptId);
  const ApproveDefeRequest = async (type) => {
    let payload: Record<string, any> = {
      pdcId: data?.params?.data?.pdcId,
      deferredRequest: type,
    };
    setLoading(true);
    try {
      const result = await updatePdcDefer(removeEmptyValues(payload));

      if (result === 200) {
        reset();
        message.success("successfully updated");
        isDeferralApproval && (await refreshPendingRequests());
        serachParampdcId && goTo(isReceiptContext ? "/receipts" : "/invoicing", { replace: true });
        props.onUpdate?.();
      } else {
        message.error("Something went wrong");
      }
    } catch (error) {
      const { response: _response } = error as AxiosError;
      message.error("Something went wrong in updating defer request");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  let defferalFee = switcherValue && Number(switcherValue[1]) ? Number(switcherValue[1]) : 0;
  let vatPer = switcherValue && Number(switcherValue[2]) ? Number(switcherValue[2]) : 0;
  const { actualAmount, amount, vatRate } = calCulateVatInPercent(defferalFee || 0, vatPer || 0);

  useEffect(() => {
    setValue("totalDeferralFee", actualAmount || 0);
  }, [actualAmount, setValue]);

  const onFinish = async (values: any) => {
    setLoader(true);
    const isReceiptDefer = Boolean(data?.params?.data?.paymentReceiptId);
    const payload: Record<string, any> = isReceiptDefer
      ? {
          paymentReceiptId: data?.params?.data?.paymentReceiptId,
          deferredDate: apiDateFormat(newDepositDate),
        }
      : {
          pdcId: data?.params?.data?.pdcId,
          deferredDate: apiDateFormat(newDepositDate),
        };

    let deferred = {
      isApplyDefferalFee: values?.isApplyDefferalFee ? "yes" : "no",
      amount: amount,
      vat: vatRate,
      total: actualAmount,
      reason: values?.defeReason,
    };
    if (isDeferralApproval) deferred["approval"] = data?.params?.data?.chequeDeferral?.approval;
    payload["deferred"] = deferred;
    try {
      let result: any;
      if (isReceiptDefer) {
        try {
          await postReceiptDefer(removeEmptyValues(payload));
          result = 200;
        } catch (e) {
          result = e;
        }
      } else {
        result = await updatePdcDefer(removeEmptyValues(payload));
      }

      if (result === 200) {
        reset();
        message.success("updated successfully");
        isDeferralApproval && (await refreshPendingRequests());

        props.onUpdate?.();
      } else {
        message.error("Something went wrong");
      }
    } catch (error: any) {
      const errMsg = error?.response?.data?.error || error?.message;
      message.error(errMsg || "Something went wrong");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleDateRange = (date) => {
    if (date) {
      setdatePicker(dayjs(date));
    }
  };

  return (
    <Form layout="vertical" className="bf-main payment-form" onFinish={handleSubmit((e) => onFinish(e))}>
      {
        <Card>
          {loader && (
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space size={24} className="w-100 text-center" direction="vertical">
                  <Spin size="large" className="ag-fontSize32" />
                </Space>
              </Col>
            </Row>
          )}
          <>
            {onApprovalConfirmation && (
              <Tag className="invoic-fm-status-header" color="cyan">
                <ApprovalHeader
                  title={
                    "Please confirm if you would like to proceed with the " +
                    (isRejection ? "rejection" : "approval") +
                    "."
                  }
                  approve={() => ApproveDefeRequest(isRejection ? "rejected" : "approved")}
                  reject={() => props.onUpdate?.()}
                  isApproveLoading={loading}
                  isRejectLoading={false}
                  approveButtonTitle={"Yes"}
                  rejectButtonTitle={"No"}
                />
              </Tag>
            )}
          </>
          <Row gutter={24}>
            {
              <>
                {
                  <Col span={12} style={{ marginTop: "5px" }}>
                    <ReactSelectField
                      fieldname="paymentModeType"
                      isRequired={true}
                      label="Payment Mode"
                      rules={{ required: "Payment Mode Required" }}
                      validate={errors.paymentModeType && "error"}
                      validMessage={errors.paymentModeType && errors.paymentModeType.message}
                      control={control}
                      iProps={{
                        placeholder: "Select payment mode",
                        isDisabled: true,
                      }}
                      selectOption={paymentModeRendering(data)}
                    />
                  </Col>
                }

                <Col span={12} style={{ marginTop: "5px" }}>
                  <ReactSelectField
                    isRequired={true}
                    fieldname="paymentStatus"
                    label={`Payment Status (${data?.params?.data?.currentStaus})`}
                    selectOption={[]}
                    control={control}
                    iProps={{
                      placeholder: "Select payment status",
                      isDisabled: true,
                    }}
                    placeholder="Select One"
                    rules={{ required: "Payment Staus Required" }}
                    validate={errors.paymentStatus && "error"}
                    validMessage={errors.paymentStatus && errors.paymentStatus.message}
                  />
                </Col>

                {
                  <Col span={12}>
                    <InputNumberField
                      fieldname="paymentRef"
                      label={"Cheque No"}
                      control={control}
                      disabled
                      inputNumberProps={{
                        placeholder: "Cheque No",
                      }}
                    />
                  </Col>
                }

                <Col span={12}>
                  <Form.Item label={"Current Cheque Date"}>
                    <DatePicker
                      disabled
                      style={{ width: "100%" }}
                      defaultValue={datePicker}
                      value={datePicker}
                      format="DD-MM-YYYY"
                      disabledDate={(_current) => true}
                      size="middle"
                      picker="date"
                      onChange={handleDateRange}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label={"New Deposit Date"}>
                    <DatePicker
                      disabled={deferredRequest}
                      style={{ width: "100%" }}
                      defaultValue={newDepositDate}
                      value={newDepositDate}
                      allowClear={false}
                      format="DD-MM-YYYY"
                      disabledDate={(current) => {
                        if (!current) return false;
                        const startDate = chequeDate.startOf("day"); // given date
                        const endDate = chequeDate.add(maxDeferralDays, "day").endOf("day");

                        return (
                          current.isBefore(startDate, "day") || // disable before given date
                          current.isAfter(endDate, "day") // disable beyond max deferral days
                        );
                      }}
                      size="middle"
                      picker="date"
                      onChange={(date) => setNewDepositDate(date)}
                    />
                  </Form.Item>
                </Col>
              </>
            }

            {
              <>
                <Col span={12}>
                  <div style={{ marginTop: "20px" }}>
                    <span>Apply Deferral Fee: </span>
                    {""}
                    <InputSwitch
                      fieldname={"isApplyDefferalFee"}
                      control={control}
                      disabled={deferredRequest}
                      valueGot={
                        (deferredRequest && data?.params?.data?.deferred?.isApplyDefferalFee === "yes") || false
                      }
                      setValue={setValue}
                    />
                  </div>
                </Col>

                <Col span={8}>
                  <InputNumberField
                    fieldname="deferralFee"
                    label={"Deferral Fee"}
                    control={control}
                    format="currency"
                    disabled={!switcherValue[0] || deferredRequest}
                    inputNumberProps={{
                      placeholder: "Deferral  Fee",
                      min: 0,
                    }}
                  />
                </Col>

                <Col span={8}>
                  <InputNumberField
                    fieldname="vat"
                    label={"Vat %"}
                    control={control}
                    disabled={!switcherValue[0] || deferredRequest}
                    inputNumberProps={{
                      placeholder: "Vat",
                      min: 0,
                      max: 100,
                    }}
                  />
                </Col>

                <Col span={8}>
                  <InputNumberField
                    fieldname="totalDeferralFee"
                    label={"Total Deferral Fee"}
                    control={control}
                    disabled
                    format="currency"
                    inputNumberProps={{
                      placeholder: "Total Deferral  Fee",
                      min: 0,
                    }}
                  />
                </Col>
              </>
            }

            {
              <Col span={24}>
                <TextAreaField
                  disabled={false}
                  label={"Defer Reason"}
                  fieldname="defeReason"
                  iProps={{ placeholder: "Defer Reason...." }}
                  initValue={data?.params?.data?.deferred?.reason || ""}
                  setValue={setValue}
                  control={control}
                  valueGot={data?.params?.data?.deferred?.reason || ""}
                />
              </Col>
            }
          </Row>
          <Row gutter={24} justify="space-between">
            <Col>
              <Button className="ef-discard-btn" onClick={() => onBack()}>
                Back
              </Button>
            </Col>
            <Col>
              {isApproved || isRejection ? (
                <Button
                  disabled={loading || onApprovalConfirmation}
                  type="primary"
                  onClick={() => setOnApprovalConfirmation(true)}
                  className="ef-approve-btn"
                  htmlType="button"
                >
                  {isRejection ? "Reject" : "Approve"}
                </Button>
              ) : (
                <Button disabled={loader} type="primary" className="ef-approve-btn" htmlType="submit">
                  {loader ? "Loading..." : isDeferralApproval ? "Send for Approval" : "Update"}
                </Button>
              )}
            </Col>
          </Row>
        </Card>
      }
    </Form>
  );
};

export default React.memo(DeferChequeDeposit);
